import React, { Component } from 'react';
import avatar from '../assets/avatar.svg';
import avatarteam from '../assets/avatarteam.svg';

class PhotoContainer extends Component {
  renderImg() {
    if (this.props.image) {
      return (
        <div
          className="img"
          style={{ backgroundImage: `url(${this.props.image})` }}
        ></div>
      );
    } else {
      if (this.props.defaultImg === 'user') {
        return <img src={avatar} className="default" alt="default avatar" />;
      } else if (this.props.defaultImg === 'team') {
        return (
          <img
            src={avatarteam}
            className="default teamavatar"
            alt="default team avatar"
          />
        );
      }
    }
  }

  render() {
    const { className, image, children, onClick } = this.props;

    return (
      <div
        className={`${className} ${!image && !children && 'empty'}`}
        onClick={onClick}
      >
        {children ? children : this.renderImg()}
      </div>
    );
  }
}

export default PhotoContainer;



// WEBPACK FOOTER //
// src/components/PhotoContainer.jsx